
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 41 41","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M.352 2.871v-.1C.452 1.41 1.56.402 2.817.402L19.117 0c.402 0 .804.151 1.106.453L40.245 20.5c1.007 1.007 1.007 2.569 0 3.526L24.047 40.244a2.525 2.525 0 01-1.761.756c-.654 0-1.258-.252-1.76-.756L.452 20.248A1.564 1.564 0 010 19.14L.352 2.871zm21.884 34.905L37.73 22.263 18.513 3.023 3.37 3.424l-.353 15.161 19.218 19.19z"}}),_c('path',{attrs:{"d":"M13.5 8c3.013 0 5.5 2.487 5.5 5.5S16.513 19 13.5 19 8 16.513 8 13.5 10.487 8 13.5 8zm0 8.13a2.653 2.653 0 002.63-2.63 2.653 2.653 0 00-2.63-2.63 2.653 2.653 0 00-2.63 2.63 2.653 2.653 0 002.63 2.63z"}})])])
          )
        }
      }
    